
let caseLogoList = [
    {
        logoSrc: 'static/images/case/logo-taigu.png',
        name: '太古地产'
    },
    {
        name: '英蓝国际',
        logoSrc: 'static/images/case/logo-yinglan.png',
    },
    {
        name: '北京国贸',
        logoSrc: 'static/images/case/logo-guomao.png',
    },
    {
        name: '发展大夏',
        logoSrc: 'static/images/case/logo-bfb.png',
    },
    {
        name: '万象城',
        logoSrc: 'static/images/case/logo-wxc.png',
    },
    {
        name: '乐成中心',
        logoSrc: 'static/images/case/logo-yuecheng.png',
    },
    {
        name: '华住集团',
        logoSrc: 'static/images/case/logo-huazhu.png',
    },
    {
        name: '上地元',
        logoSrc: 'static/images/case/logo-sdy.png',
    },
    {
        name: '余之城',
        logoSrc: 'static/images/case/logo-yzc.png',
    },
    {
        name: '阿里云',
        logoSrc: 'static/images/case/logo-alibaba.png',
    },
    {
        name: '特斯拉',
        logoSrc: 'static/images/case/logo-tsl.png',
    },
    {
        name: 'NIO',
        logoSrc: 'static/images/case/logo-weilai.png',
    },
    {
        name: 'Zeekr',
        logoSrc: 'static/images/case/logo-zeekr.png',
    },
    {
        name: '金山云',
        logoSrc: 'static/images/case/logo-jinshanyun.png',
    },
    {
        name: '莱佛士国际医院',
        logoSrc: 'static/images/case/logo-raffles.png',
    },
    {
        name: '高合汽车',
        logoSrc: 'static/images/case/logo-gaohe.png',
    },
    {
        name: '亨斯迈',
        logoSrc: 'static/images/case/logo-huntsman.png',
    },
    {
        name: '包玉刚学校',
        logoSrc: 'static/images/case/logo-byg.png',
    },
];
export default {
    caseLogoList: Array.from(caseLogoList, (item,index) => {
        let defaultDelay = 1;
        if([0, 2, 5, 8, 14, 16].includes(index)) defaultDelay = 0.5;
        else if([11].includes(index)) defaultDelay = 0.3;
        else if([4, 7, 10, 13].includes(index)) defaultDelay = 0.2;
        else if([3, 6, 9, 12, 17].includes(index)) defaultDelay = 0.1;
        return {
          ...item,
          delay: defaultDelay
        }
    }),
    caseList:[
        {
            img: 'static/images/case/aly.png',
            title: '阿里云数据中心',
            desc: '阿里云已建成五大超级数据中心基地，辐射京津冀、长三角、粤港澳三大经济带，可为中小企业提供云计算、大数据和人工智能服务，也为阿里云业务发展提供强有力的基础设施支持，具有先进性、示范性。已与其张北庙滩、河源江东等数个数据中心达成合作。',
            lines: [
                {
                    text: '智慧金融',
                }
            ]
        },
        {
            img: 'static/images/case/guomao.png',
            title: '国贸物业',
            desc: '国贸物业酒店管理有限公司是中国国际贸易中心的全资子公司，成立于1998年。通过不断提高自身管理素质，追求完美服务，满足客户对物业和酒店服务的需求，已在物业和酒店领域内形成了“国贸”管理服务品牌。已与其包括北京国贸大厦在内的10余个项目达成合作。',
            lines: [
                {
                    text: '智慧城市（BIM大数据平台）',
                }
            ]
        },
        {
            img: 'static/images/case/tesila.png',
            title: '特斯拉',
            desc: '特斯拉是以IT理念造车的先驱，重新定义汽车这一百年未变的事物，他们想让汽车变得更智能，更聪明，更富有人性。目前在全国拥有200多家线下体验店。已针对全国连锁门店的运维服务部分建立了合作关系。',
            lines: [
                {
                    text: '智慧电力系统',
                }
            ]
        },
        {
            img: 'static/images/case/sanlitun.png',
            title: '三里屯太古里',
            desc: '三里屯太古里是由太古房地产开发的商业综合体项目。它位于北京市朝阳区以工体北路与三里屯路交汇处。由19座低密度的当代建筑布局而成.整个项目、分为南、北两个区域。既与周边建筑融合在同一个域区之中，同时也保持着相对独立性。项目占地5.3万平方米，建筑面积17.2万平方米。',
            lines: [
                {
                    text: '智慧园区系统',
                }
            ]
        },
        {
            img: 'static/images/case/yuecheng.png',
            title: '乐成中心',
            desc: '乐成中心是国贸商圈与东三环黄金交点，CBD地铁上盖甲级写字楼乐成中心位于东三环、广渠路黄金交汇处，由两栋26层体量相当的甲级写字楼与一座三层的商业裙楼组成，为CBD商圈内罕有的优质商务综合。写字楼立面材质与国贸同级，甲级硬件标准与高端商务形象相得益彰。项目占地1.5万平方米，建筑面积11.3万平方米。',
            lines: [
                {
                    text: '智慧社区系统',
                }
            ]
        },
        {
            img: 'static/images/case/gaohe.png',
            title: '高合汽车',
            desc: '华人运通前瞻性业务布局将聚焦五大板块：全新智能汽车的开发与制造；车辆、充电网络及能源的共享；车联网IoV及先进开放的自动驾驶技术；支持智捷交通的延伸；参与智慧城市的开发和构建。',
            lines: [
                {
                    text: '智慧工地系统',
                }
            ]
        },
        {
            img: 'static/images/case/sny.png',
            title: '首农元中心',
            desc: '元中心项目又名中关村移动智能服务创新园项目，位于海淀区西二旗中路29号院，南邻小米移动互联网产业园，西距中关村软件园1公里，是“中关村科学城”重点建设项目。产业定位为移动互联网城市与企业的智能应用与终端发展，企业级移动互联网生产服务，面向智慧城市的移动互联网公共服务业态，成为新一代信息技术、集成电路、智能装备、新能源新材料、人工智能、软件和信息服务业及科技服务业科研办公基地。项目占地6万平方米，建筑面积34.3万平方米。',
            lines: [
                {
                    text: '楼宇智慧物联网（IOT）',
                }
            ]
        },
        {
            img: 'static/images/case/hsm.png',
            title: '亨斯迈化学研发中心（上海）',
            desc: '亨斯迈化学研发中心(上海)有限公司是中外合资企业，主要从事聚氨酯产品、功能化学品产品、纺织染化产品以及相关应用技术、仪器和器材的研究、开发。亨斯迈目前在中国的累计投资已达到150亿元人民币。该在研发中心的研发实力位于行业前列。',
            lines: [
                {
                    text: '楼宇智慧物联网（IOT）',
                }
            ]
        },
        {
            img: 'static/images/case/yzc.png',
            title: '余之城',
            desc: '余之城生活广场商业、办公于一体的城市综合体，位于浙江杭州余杭区，隶属于临平新城核心区，同时又处于政府规划的兿尚小镇中。项目周边聚集人文、教育、交通、产业、商业、医疗等中心资源，是杭州新锐阶层安居乐业的明智之选 临平新城拥有“一中心一湖体”的政府规划。该项目占地8万平方米，建筑面积23.5万平方米。',
            lines: [
                {
                    text: '楼宇智慧物联网（IOT）',
                }
            ]
        },
        {
            img: 'static/images/case/byg.png',
            title: '包玉刚学校',
            desc: '上海民办包玉刚实验学校（以下简称包校）是一所开创性而具有国际视野的中国学校。学校成立于2007年，是一所非营利的双语学校，由包氏家族为纪念爱国爱乡的企业家、政治家、慈善家，已故船王包玉刚爵士而创建。包校目前有1500左右名中外籍学生，提供小学一年级至高中十二年制的学历教育。',
            lines: [
                {
                    text: '楼宇智慧物联网（IOT）',
                }
            ]
        },
        {
            img: 'static/images/case/shs.png',
            title: '社会山文旅港',
            desc: '社会山文旅港坐落于天津市高铁南站旁，交通便捷配套齐全，项目建有社会山会议中心酒店、都喜温泉酒店、城市酒店、末那精品酒店、嘉佑温泉水世界、社会山购物中心及城南往市主题街区，提供会议、旅游、住宿、休闲、购物等一站式服务。该项目占地8万平方米， 建筑面积29.5万平方米。',
            lines: [
                {
                    text: '楼宇智慧物联网（IOT）',
                }
            ]
        },
        {
            img: 'static/images/case/hz.png',
            title: '华住集团',
            desc: '华住集团，是世界知名的酒店集团，创立于2005年。截至2022年6月30日，华住集团在17个国家经营8,176家酒店，拥有近14万名员工。华住集团旗下经营30个酒店及公寓品牌，覆盖从豪华到经济型市场。华住已经成为全球发展最快的酒店集团之一。',
            lines: [
                {
                    text: '楼宇智慧物联网（IOT）',
                }
            ]
        }
    ],
    navList: [
        {
            name:'智慧开发区',
            children:[
                {
                    img: 'static/images/case/202006121615565ee339bc57aca.png',
                    title: '智慧党建',
                    desc: '采用人脸识别、智能分析、大数据等前沿技术，提升安全防范能力和处理效率，助力金融行业业务发展。',
                    lines: [
                        {
                            text: '智慧金融',
                        }
                    ]
                },
                {
                    img: 'static/images/case/202006121616285ee339dcc2978.png',
                    title: '智慧运营',
                    desc: '智慧城市把新一代信息技术充分应用在城市中各行各业，以提高城镇化质量、实现精细化和动态管理，并提升城市管理成效和改善生活质量。',
                    lines: [
                        {
                            text: '智慧城市（BIM大数据平台）',
                        }
                    ]
                },
                {
                    img: 'static/images/case/202006121616525ee339f440503.png',
                    title: '资产管理',
                    desc: '以深度学习视频分析算法、物联网、大数据等技术为依托，为电力行业和用电单位的用电安全防范、智能预警提供有效的技术手段。',
                    lines: [
                        {
                            text: '智慧电力系统',
                        }
                    ]
                },
                {
                    img: 'static/images/case/202008130915425f34943e44971.jpg',
                    title: '园区宣传',
                    desc: '提升园区智能化水平，打造绿色、安全、高效的智慧园区。',
                    lines: [
                        {
                            text: '智慧园区系统',
                        }
                    ]
                },
                {
                    img: 'static/images/case/202008261026005f45c8385cc2e.png',
                    title: '智慧大屏',
                    desc: '利用科技手段，建立社区人员、车辆、房屋全面管理机制，让社区管理进入智能时代。',
                    lines: [
                        {
                            text: '智慧社区系统',
                        }
                    ]
                },
                {
                    img: 'static/images/case/202006121617165ee33a0c3bf00.png',
                    title: '政策匹配',
                    desc: '智慧工地运用信息化手段，围绕施工过程管理，建立互联协同、智能生产、科学管理的施工项目信息化生态圈。',
                    lines: [
                        {
                            text: '智慧工地系统',
                        }
                    ]
                },
                {
                    img: 'static/images/case/202008261039075f45cb4bc11f1.png',
                    title: '应急疏散',
                    desc: '通过智能化技术和手段，将智能化系统设备与建筑环境有机结合，提高能源利用率，真正体现智能化系统的建设目标和应用价值。',
                    lines: [
                        {
                            text: '楼宇智慧物联网（IOT）',
                        }
                    ]
                }
            ]
        },
        {
            name:'智慧园区',
            children:[
                {
                    img: 'static/images/case/202006121616525ee339f440503.png',
                    title: '智慧运营',
                    desc: '以深度学习视频分析算法、物联网、大数据等技术为依托，为电力行业和用电单位的用电安全防范、智能预警提供有效的技术手段。',
                    lines: [
                        {
                            text: '智慧电力系统',
                        }
                    ]
                },
                {
                    img: 'static/images/case/202008130915425f34943e44971.jpg',
                    title: '资产管理',
                    desc: '提升园区智能化水平，打造绿色、安全、高效的智慧园区。',
                    lines: [
                        {
                            text: '智慧园区系统',
                        }
                    ]
                },
                {
                    img: 'static/images/case/202008261026005f45c8385cc2e.png',
                    title: '能耗优化',
                    desc: '利用科技手段，建立社区人员、车辆、房屋全面管理机制，让社区管理进入智能时代。',
                    lines: [
                        {
                            text: '智慧社区系统',
                        }
                    ]
                },
                {
                    img: 'static/images/case/202006121617165ee33a0c3bf00.png',
                    title: '环境健康',
                    desc: '智慧工地运用信息化手段，围绕施工过程管理，建立互联协同、智能生产、科学管理的施工项目信息化生态圈。',
                    lines: [
                        {
                            text: '智慧工地系统',
                        }
                    ]
                },
                {
                    img: 'static/images/case/202008261039075f45cb4bc11f1.png',
                    title: '园区招商',
                    desc: '通过智能化技术和手段，将智能化系统设备与建筑环境有机结合，提高能源利用率，真正体现智能化系统的建设目标和应用价值。',
                    lines: [
                        {
                            text: '楼宇智慧物联网（IOT）',
                        }
                    ]
                }
            ]
        },
        {
            name:'智慧楼宇',
            children:[
                {
                    img: 'static/images/case/202006121617165ee33a0c3bf00.png',
                    title: '智慧运营',
                    desc: '智慧工地运用信息化手段，围绕施工过程管理，建立互联协同、智能生产、科学管理的施工项目信息化生态圈。',
                    lines: [
                        {
                            text: '智慧工地系统',
                        }
                    ]
                },
                {
                    img: 'static/images/case/202008261039075f45cb4bc11f1.png',
                    title: '资产管理',
                    desc: '通过智能化技术和手段，将智能化系统设备与建筑环境有机结合，提高能源利用率，真正体现智能化系统的建设目标和应用价值。',
                    lines: [
                        {
                            text: '楼宇智慧物联网（IOT）',
                        }
                    ]
                }
            ]
        },
    ]
}


// WEBPACK FOOTER //
// ./src/components/case/data.js